"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDisplayTagDto = void 0;
class CreateDisplayTagDto {
    /**
     * @deprecated Use `name` instead.
     */
    title;
    name;
    // Min 1
    pricingMultiplier;
}
exports.CreateDisplayTagDto = CreateDisplayTagDto;
